import { AppLanguage, pickByLanguage } from "@/lib/language";

export const landingFaqs = [
  {
    question: {
      pt: "Como adicionar um chatbot de IA no meu Instagram ou perfil de rede social?",
      en: "How do I add an AI chatbot to my Instagram or social profile?",
    },
    answer: {
      pt: "O Qlivar cria uma página de perfil com chatbot IA integrado. Você configura o agente com as informações do negócio e publica o link na bio.",
      en: "Qlivar gives you a profile page with a built-in AI chatbot. Configure it with your business information and publish the link in your bio.",
    },
  },
  {
    question: {
      pt: "Preciso entender de tecnologia para configurar?",
      en: "Do I need to be technical to set this up?",
    },
    answer: {
      pt: "Não. A proposta é montar a página, adicionar seus blocos e publicar em poucos minutos, sem código e sem plugins.",
      en: "No. The whole point is to set up the page, add your blocks, and publish in minutes, without code or plugins.",
    },
  },
  {
    question: {
      pt: "Consigo vender produtos digitais sem ter um site?",
      en: "Can I sell digital products without a website?",
    },
    answer: {
      pt: "Sim. O mini-store do Qlivar permite vender ebooks, cursos, arquivos e outros produtos digitais direto da página.",
      en: "Yes. Qlivar's mini-store lets you sell ebooks, courses, files, and other digital products right from the page.",
    },
  },
  {
    question: {
      pt: "O chatbot responde quando estou offline?",
      en: "Will the chatbot respond when I'm offline?",
    },
    answer: {
      pt: "Sim. Esse é um dos principais usos do agente: responder dúvidas, encaminhar para links e manter o atendimento vivo fora do seu horário.",
      en: "Yes. That's one of the main use cases: answering questions, routing people to links, and keeping your operation alive outside your schedule.",
    },
  },
  {
    question: {
      pt: "Posso usar meu próprio domínio?",
      en: "Can I use my own domain?",
    },
    answer: {
      pt: "Sim. Os planos Professional e Business permitem conectar domínio personalizado com SSL incluso.",
      en: "Yes. Professional and Business let you connect a custom domain with SSL included.",
    },
  },
  {
    question: {
      pt: "Preciso de cartão para começar no plano gratuito?",
      en: "Do I need a card to start on the free plan?",
    },
    answer: {
      pt: "Não. O plano gratuito não exige cartão. Nos planos pagos você recebe trial de 7 dias.",
      en: "No. The free plan does not require a card. Paid plans include a 7-day free trial.",
    },
  },
];

export function buildFaqSchema(language: AppLanguage) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    name: language === "pt" ? "Perguntas Frequentes" : "Frequently Asked Questions",
    mainEntity: landingFaqs.map((faq) => ({
      "@type": "Question",
      name: pickByLanguage(language, faq.question),
      acceptedAnswer: {
        "@type": "Answer",
        text: pickByLanguage(language, faq.answer),
      },
    })),
  };
}
